import { render, staticRenderFns } from "./StudentMovementReport.vue?vue&type=template&id=9fdce2a6&scoped=true"
import script from "./StudentMovementReport.vue?vue&type=script&lang=js"
export * from "./StudentMovementReport.vue?vue&type=script&lang=js"
import style0 from "./StudentMovementReport.vue?vue&type=style&index=0&id=9fdce2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdce2a6",
  null
  
)

export default component.exports